import {DELETE_SUB_SCOPE, GET_ALL_SCOPES, PATCH_SUB_SCOPE, POST_SUB_SCOPE} from '../actiontypes';
import {deleteSubScopeUrl, getAllScopesUrl, editSubScopesUrl} from '../apiUrls';
import {patchGeneratorPayload} from './patchGeneratorPayload';

/**
 * Returns an action to be dispatched and treated by the api-middleware, ultimately making an API call through Axios.
 * Represents a request all the active scopes for the given engagements.
 * @param {Number} engagementId Engagement ID.
 * @returns {Object} An action object.
 */
export const getAllScopes = (engagementId) => {
	const url = getAllScopesUrl(engagementId);

	return {
		type: GET_ALL_SCOPES,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		}
	};
};

export const createSubScope = (engagementId, payload) => {
	const url = getAllScopesUrl(engagementId);

	return {
		type: POST_SUB_SCOPE,
		meta: {
			api: {
				url,
				method: 'POST',
				data: payload
			}
		}
	};
};

export const editSubScope = (engagementId, scopeId, payload) => {
	const url = editSubScopesUrl(engagementId, scopeId);
	const data = patchGeneratorPayload(payload);
	return {
		type: PATCH_SUB_SCOPE,
		meta: {
			api: {
				url,
				method: 'PATCH',
				data: data
			}
		}
	};
};


export const deleteSubScope = (engagementId, scopeId) => {
	const url = deleteSubScopeUrl(engagementId, scopeId);

	return {
		type: DELETE_SUB_SCOPE,
		meta: {
			api: {
				url,
				method: 'DELETE'
			},
			scopeId
		}
	};
};
